import { all, put, call, takeLatest, select } from 'redux-saga/effects';
import ApiService from '@/services/Api';
import actions, { actionTypes } from './actions';
import modalsActions from '../modals/actions';

function* fetchResources({ payload }) {
  try {
    const { data } = yield call(ApiService.fetchResources, payload);
    yield put(actions.fetchSuccess(data));
  } catch (error) {
    yield put(actions.fetchFailed(error));
  }
}

function* uploadResource({ payload }) {
  const { tableOptions } = yield select(({ resources }) => ({
    tableOptions: resources.tableOptions,
  }));
  try {
    const { data } = yield call(ApiService.uploadResource, payload);
    yield put(actions.uploadResourceSuccess(data));
    yield put(actions.fetchResources({ page: tableOptions.page, limit: tableOptions.limit }));
    yield put(modalsActions.toggleUploadResourceModal(false));
  } catch (error) {
    yield put(actions.uploadResourceFailed(error));
  }
}

function* deleteResource({ payload }) {
  const { tableOptions } = yield select(({ resources }) => ({
    tableOptions: resources.tableOptions,
  }));
  try {
    yield call(ApiService.deleteResource, payload);
    yield put(actions.deleteResourceSuccess());
    yield put(actions.fetchResources({ page: tableOptions.page, limit: tableOptions.limit }));
  } catch (error) {
    yield put(actions.deleteResourceFailed(error));
  }
}

export default function* () {
  yield all([
    takeLatest(actionTypes.FETCH_RESOURCES, fetchResources),
    takeLatest(actionTypes.UPLOAD_RESOURCE, uploadResource),
    takeLatest(actionTypes.DELETE_RESOURCE, deleteResource),
  ]);
}
